module.exports = __webpack_public_path__ + "img/cresc_4.f702e957.png";